(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-hs4-finder]').forEach(el => {
      if(el.dataset.ready)return;el.dataset.ready='true';
      el.querySelectorAll('.hs4-choice').forEach(btn=>btn.addEventListener('click',()=>{
        el.querySelectorAll('.hs4-choice').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));
        el.querySelectorAll('.hs4-finder-result').forEach(p=>p.hidden=p.id!==btn.getAttribute('aria-controls'));
      }));
    });
    root.querySelectorAll('[data-hs4-product]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      const data=JSON.parse(el.querySelector('[data-variants]').textContent),select=el.querySelector('[name=id]');
      const stage=el.querySelector('.hs4-stage'),photo=stage.querySelector('img'),basePhoto=photo.src;
      const thumbs=Array.from(el.querySelectorAll('[data-photo]'));
      const caption=el.querySelector('[data-gallery-caption]');
      const productTitle=el.querySelector('.hs4-gallery').dataset.productTitle||photo.alt;
      const showPhoto=b=>{
        photo.src=b.dataset.photo;
        photo.removeAttribute('srcset');
        photo.alt=productTitle+', '+(b.dataset.caption||b.getAttribute('aria-label'));
        if(caption)caption.textContent=b.dataset.caption||'Product view';
        stage.dataset.zoom='false';
        el.querySelector('.hs4-zoom')?.setAttribute('aria-pressed','false');
        thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
      };
      const fmt=n=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:el.dataset.currency}).format(n/100);
      const update=(changeUrl=true)=>{
        const v=data.find(v=>String(v.id)===select.value);if(!v)return;
        el.querySelectorAll('[data-price]').forEach(p=>p.textContent=fmt(v.price));
        el.querySelectorAll('[data-buy]').forEach(b=>{b.disabled=!v.available;b.textContent=v.available?'Add to bag':'Currently unavailable';});
        el.querySelector('[data-stock-note]').textContent=v.available?'':'This option is not currently available to order.';
        const stockStatus=el.querySelector('[data-stock-status]');
        if(stockStatus){
          stockStatus.dataset.available=String(v.available);
          stockStatus.querySelector('[data-stock-label]').textContent=v.available?'In stock':'Currently unavailable';
        }
        if(changeUrl){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
        const main=el.querySelector('[data-gallery-main]')||thumbs[0];
        if(main){
          main.dataset.photo=v.hourstead_image||basePhoto;
          main.querySelector('img').src=main.dataset.photo;
          main.dataset.caption='Product view'+(v.title==='Default Title'?'':' · '+v.title);
          main.setAttribute('aria-label',main.dataset.caption);
          showPhoto(main);
        }
      };
      if(select.tagName==='SELECT')select.addEventListener('change',()=>update());
      update(false);
      el.querySelector('.hs4-zoom')?.addEventListener('click',e=>{const z=stage.dataset.zoom!=='true';stage.dataset.zoom=String(z);e.currentTarget.setAttribute('aria-pressed',String(z));});
      thumbs.forEach(b=>b.addEventListener('click',()=>showPhoto(b)));
      const sticky=el.querySelector('.hs4-mobile-buy'),buy=el.querySelector('.hs4-buyrow');
      if(sticky&&buy){new IntersectionObserver(([e])=>sticky.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0)).observe(buy);}
    });
    root.querySelectorAll('[data-hs4-sort]').forEach(s=>s.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.assign(u);}));
  };
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
